<template>
  <!-- 只处理路由替换,兼容老链接 -->
  <router-view />
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router';
/*********** 响应式数据 *************/
const route = useRoute();
const router = useRouter();
const { query, name } = route;
const { planId: id, share } = query;
if (name === 'schedulePlan') {
  // 重新拆分为独立页面
  if ((share === null || share === '1') && id) {
    // 分享页
    // 重定向到share页面
    router.replace({ path: '/schedule-plan/share', query });
  } else if (id) {
    // 重定向到edit页面
    router.replace({ path: '/schedule-plan/edit', query });
  } else {
    // 新建
    router.replace({ path: '/schedule-plan/add', query });
  }
}
</script>
<style lang="scss">
@import '@client/styles/_mixins.scss';

.schedule-plan {
  .name-editing-input {
    width: px2rem144(600);
  }
  .schedule-overview-textarea {
    // @apply bg-dark-500;
    .arco-textarea[disabled] {
      @apply text-white;
      -webkit-text-fill-color: #fff;
    }
  }
  .opened-panel-closed {
    width: 0;
  }
  .right-inner-drawer-grid {
    position: absolute;
    top: 0;
    left: 0;
    width: 1px;
    height: 100%;
    z-index: 199;
  }
  .side-panel-toggle-btns {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
